export class CameraMotionModel {
    constructor(
        public zoom = 0,
        public panX = 0,
        public panY = 0,
        public rotateX = 0,
        public rotateY = 0
    ) {}
}
